var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4879_35512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 3V11.25H4.3725L6.3075 9.3075L5.25 8.25L1.5 12L5.25 15.75L6.3075 14.6925L4.3725 12.75H9V21H10.5V3H9Z",
    fill: "#AEB3C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8.25L17.6925 9.3075L19.6275 11.25H15V3H13.5V21H15V12.75H19.6275L17.6925 14.6925L18.75 15.75L22.5 12L18.75 8.25Z",
    fill: "#AEB3C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4879_35512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResize);
export default __webpack_public_path__ + "static/media/Resize.419e270dc6611fe68b764ba8535aee89.svg";
export { ForwardRef as ReactComponent };